import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

interface Props {
  value: string;
}

export function QRPanel({ value }: Props) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, {
      errorCorrectionLevel: 'M',
      margin: 1,
      width: 320,
      color: { dark: '#0f172a', light: '#ffffff' },
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value]);

  return (
    <div className="flex w-full items-center gap-4 rounded-2xl bg-white p-4 ring-1 ring-slate-200">
      <div className="flex h-28 w-28 shrink-0 items-center justify-center rounded-xl bg-slate-50 ring-1 ring-slate-200">
        {dataUrl ? (
          <img
            src={dataUrl}
            alt="현재 페이지를 모바일에서 열기 위한 QR 코드"
            width={104}
            height={104}
            className="h-26 w-26"
          />
        ) : (
          <div className="h-20 w-20 animate-pulse rounded bg-slate-200" />
        )}
      </div>
      <div className="flex min-w-0 flex-col">
        <p className="text-sm font-semibold text-slate-900">
          모바일에서 열어보세요
        </p>
        <p className="mt-1 text-xs leading-relaxed text-slate-500">
          휴대폰 카메라로 QR을 스캔하면 동일한 알림을 모바일에서 이어볼 수 있어요.
        </p>
      </div>
    </div>
  );
}
